<lib-keyboard-activity #keyboard [targetWord]="null">
  <div class="ml-4 flex items-center gap-2 py-4" input-bar>
    <button
      (click)="keyboard.removeLastKey()"
      class="border-surface-300 grid h-full w-12 cursor-pointer place-items-center rounded-md border-2 bg-white p-2.5 text-2xl disabled:opacity-25"
    >
      <svg fill="none" viewBox="0 0 32 26" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.04 19.4L19.2 15.24L23.36 19.4L25.6 17.16L21.44 13L25.6 8.84L23.36 6.6L19.2 10.76L15.04 6.6L12.8 8.84L16.96 13L12.8 17.16L15.04 19.4ZM11.2 25.8C10.6933 25.8 10.2133 25.6867 9.76 25.46C9.30667 25.2333 8.93333 24.92 8.64 24.52L0 13L8.64 1.48C8.93333 1.08 9.30667 0.766664 9.76 0.539997C10.2133 0.31333 10.6933 0.199997 11.2 0.199997H28.8C29.68 0.199997 30.4333 0.51333 31.06 1.14C31.6867 1.76666 32 2.52 32 3.4V22.6C32 23.48 31.6867 24.2333 31.06 24.86C30.4333 25.4867 29.68 25.8 28.8 25.8H11.2ZM4 13L11.2 22.6H28.8V3.4H11.2L4 13Z"
          fill="#334155"
        />
      </svg>
    </button>

    <button
      (click)="addSpace()"
      class="border-surface-300 grid h-full w-12 cursor-pointer place-items-center rounded-md border-2 bg-white p-2.5 text-2xl disabled:opacity-25"
    >
      <svg fill="none" viewBox="0 0 24 10" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 9.5V0.5H3V6.5H21V0.5H24V9.5H0Z" fill="#334155" />
      </svg>
    </button>
  </div>
</lib-keyboard-activity>
